import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { ColorUtil } from '../../../utils/color-util';
import {
  backgroundColorNames,
  backgroundColorHexes,
} from '../../../theme/axiom-theme';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Flashy } from '../Flashy/Flashy';

export const AccoladeColors = Object.values(backgroundColorNames);
export type AccoladeColorType = (typeof AccoladeColors)[number];

export interface AccoladeProps {
  children: React.ReactElement | string | null | number;
  className?: string;
  color?: AccoladeColorType;
  label?: string;
  name?: string;
  outline?: boolean;
}

export const Accolade = ({
  children,
  className,
  color = backgroundColorNames.navyBlue,
  label,
  name = 'ACCOLADE',
  outline = false,
}: AccoladeProps) => {
  const contents = typeof children === 'number' ? `${children}` : children;

  const isChildString = typeof contents === 'string';
  const isChildStringOfLessThanFourChars = isChildString && contents.length < 4;

  return (
    <Layout
      position="middle"
      horizontalGutter="10px"
      name={name}
      className="accolade"
    >
      <LayoutItem
        className={AttrsHelper.formatClassname('accolade-svg-wrapper')}
      >
        <svg
          width="32"
          height="32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-test={`${name}-svg-path`}
            d="M16.5135 1.07752L31 6.68521V25.2988L15.4604 30.9319L1 25.3156V6.70118L16.5135 1.07752Z"
            className={AttrsHelper.formatClassname(
              className,
              ColorUtil.nameClass({ color, prefix: 'background' })
            )}
            strokeWidth={2}
            stroke={outline ? backgroundColorHexes[color] : 'none'}
            fill={outline ? 'none' : backgroundColorHexes[color]}
          />
        </svg>
        <div
          data-test={`${name}-content-container`}
          className={AttrsHelper.formatClassname(
            'accolade-content',
            isChildStringOfLessThanFourChars && 'accolade-string-content',
            !outline &&
              `${ColorUtil.nameClass({ color, prefix: 'background' })}-text`
          )}
        >
          {isChildStringOfLessThanFourChars || !isChildString ? (
            <Flashy name={`${name}-accolade-content`} bold>
              {contents}
            </Flashy>
          ) : null}
        </div>
      </LayoutItem>
      {label ? (
        <div data-test={`${name}-label`} className="accolade-label max-lines-1">
          {label}
        </div>
      ) : null}
    </Layout>
  );
};
